import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
    query reservationHourlyTrends($branchId: ID!, $startTime: DateTime!, $endTime: DateTime!) {
        daily: analytic_hourlyReservations(
            branchId: $branchId
            startTime: $startTime
            endTime: $endTime
            lastDayCount: 1
        ) {
            hour
            count
        }
    }
`);

export default function useReservationHourlyTrends(
  branchId: string | undefined,
  startTime: string,
  endTime: string,
) {
  return useQuery(QUERY, {
    variables: {
      branchId: branchId ?? '',
      startTime,
      endTime,
    },
    skip: !branchId,
  });
}
